var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18.75 5H22.5C23.8875 5 25 6.1125 25 7.5V21.25C25 22.6375 23.8875 23.75 22.5 23.75H2.5C1.1125 23.75 0 22.6375 0 21.25V7.5C0 6.1125 1.1125 5 2.5 5H6.25V2.5C6.25 1.1125 7.3625 0 8.75 0H16.25C17.6375 0 18.75 1.1125 18.75 2.5V5ZM16.25 2.5H8.75V5H16.25V2.5ZM22.5 21.25H2.5V18.75H22.5V21.25ZM2.5 15H22.5V8.75C22.5 8.0625 21.9375 7.5 21.25 7.5H18.75V8.75C18.75 9.4375 18.1875 10 17.5 10C16.8125 10 16.25 9.4375 16.25 8.75V7.5H8.75V8.75C8.75 9.4375 8.1875 10 7.5 10C6.8125 10 6.25 9.4375 6.25 8.75V7.5H3.75C3.0625 7.5 2.5 8.0625 2.5 8.75V15Z",
  fill: "#EE151B"
});

function SvgJobsRed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobsRed);
export default __webpack_public_path__ + "static/media/JobsRed.95712ad6.svg";
export { ForwardRef as ReactComponent };